import React, { useState, useEffect } from 'react';
import { FormControl, InputLabel, Select, MenuItem, CircularProgress } from '@mui/material';
import { organizationApi } from '../../../services/api';
import { useAlert } from '../../../contexts/AlertContext';
import { GRADE_RETURN_TYPES } from '../../../constants/selectorReturnTypes';

// Legacy export for backward compatibility
export const RETURN_VALUE_TYPES = GRADE_RETURN_TYPES;

const GradeSelector = ({ 
  value, 
  onChange, 
  label = "Grade",
  required = false,
  disabled = false,
  fullWidth = true,
  returnValue = GRADE_RETURN_TYPES.ID, // GRADE_RETURN_TYPES.ID or GRADE_RETURN_TYPES.NAME
  // Remove open, onOpen, onClose props - let Material-UI handle dropdown state
  ...props 
}) => {
  const [grades, setGrades] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { showAlert } = useAlert();

  useEffect(() => {
    const fetchGrades = async () => {
      try {
        setIsLoading(true);
        const gradesData = await organizationApi.getAllGrades();
        setGrades(gradesData);
      } catch (error) {
        showAlert('Failed to load grades', 'error', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchGrades();
  }, [showAlert]);

  const handleChange = (event) => {
    if (onChange) {
      const selectedGradeId = event.target.value;
      
      if (returnValue === GRADE_RETURN_TYPES.NAME) {
        // Find the grade object and return its label
        const selectedGrade = grades.find(grade => grade.id === selectedGradeId);
        onChange(selectedGrade?.label || '');
      } else {
        // Return the ID (default behavior)
        onChange(selectedGradeId);
      }
    }
  };

  // Find the selected grade object from the ID or name
  const selectedGrade = grades.find(grade => {
    if (returnValue === GRADE_RETURN_TYPES.NAME) {
      return grade.label === value;
    } else {
      return grade.id === value;
    }
  }) || null;

  return (
    <FormControl fullWidth={fullWidth} required={required} disabled={disabled || isLoading} {...props}>
      <InputLabel>{label}</InputLabel>
      <Select
        value={selectedGrade?.id || ''}
        onChange={handleChange}
        label={label}
        disabled={disabled || isLoading}

        endAdornment={
          isLoading ? <CircularProgress color="inherit" size={20} /> : null
        }
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: 300,
              zIndex: 1350 // Ensure dropdown appears above table
            }
          }
        }}
      >
        {grades.map(grade => (
          <MenuItem key={grade.id} value={grade.id}>
            {grade.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default GradeSelector; 